module.exports = __webpack_public_path__ + "static/media/carmart_ad.c1dbe4f1.png";